export const AddOnsEndpoint = (makeRequest) => {
    return {
        // Returns OTCs broken down into categories. Reserves the right to withhold certain OTCs if OOS or based on the order/patient.
        fetchCategorized(params, options) {
            return makeRequest('GET', '/v1/add_ons/fetch_categorized', params, options);
        },
        fetchByProductIDs(params, options) {
            return makeRequest('GET', '/v1/add_ons/fetch_by_product_ids', params, options);
        },
        fetchFeatured(params, options) {
            return makeRequest('GET', '/v1/add_ons/fetch_featured', params, options);
        },
        fetchRecommended(params, options) {
            return makeRequest('GET', '/v1/add_ons/fetch_recommended', params, options);
        },
        fetchRelated(params, options) {
            return makeRequest('GET', '/v1/add_ons/fetch_related', params, options);
        },
        // @deprecated - use AddToCart
        createPrescription(params, options) {
            return makeRequest('POST', '/v1/add_ons/create_prescription', params, options);
        },
        addToCart(params, options) {
            return makeRequest('POST', '/v1/add_ons/add_to_cart', params, options);
        },
        updatePrescription(params, options) {
            return makeRequest('PUT', '/v1/add_ons/update_prescription', params, options);
        },
        deletePrescription(params, options) {
            return makeRequest('DELETE', '/v1/add_ons/delete_prescription', params, options);
        },
        addToShipment(params, options) {
            return makeRequest('POST', '/v1/add_ons/add_to_shipment', params, options);
        },
        fetchTherapeuticAreaUpsell(params, options) {
            return makeRequest('GET', '/v1/add_ons/fetch_therapeutic_area_upsell', params, options);
        },
    };
};
//# sourceMappingURL=add_ons_endpoint.js.map